import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20movie%20theater%20interior%20with%20glowing%20red%20velvet%20curtains%2C%20empty%20stage%20with%20dramatic%20spotlight%2C%20atmospheric%20smoke%2C%20luxurious%20cinema%20ambiance%2C%20deep%20shadows%2C%20rich%20warm%20accents%2C%20epic%20cinematic%20photography&width=1920&height=1080&seq=hero-bg-main&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-background-50"></div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
          <i className="ri-fire-line text-primary-400 text-sm"></i>
          <span className="text-xs font-medium text-primary-300">每日更新 · 海量资源</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 mb-4 leading-tight font-heading">
          海量高清影视
          <br />
          <span className="text-primary-400">免费在线观看</span>
        </h1>

        <p className="text-sm md:text-base text-foreground-400 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚全球热门电影、电视剧、综艺、动漫资源，更新及时、高清流畅、无需注册，打开即看。
          超过3万部影视作品，随时随地畅享精彩内容。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/movie"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始观影
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-background-200/70 hover:bg-background-200 text-foreground-200 font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-12">
          {[
            { value: '32,500+', label: '影视资源' },
            { value: '128万+', label: '日活用户' },
            { value: '98%', label: '用户满意度' },
            { value: '24h', label: '极速更新' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                {stat.value}
              </div>
              <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}